/* eslint-disable no-unused-vars */
import { Box, Button, Card, CardActions, CardContent, CardHeader, FormLabel, TextField, Typography } from "@mui/material"

import { useDispatch, useSelector } from "react-redux"
import { Lang, useFormInputValidation } from "react-form-input-validation"
import { getAdForm, putReg } from "../../../redux/slices/adFormSlice"
import TshirtSizeRF from "./TshirtSizeRF"
import { useSnackbar } from "notistack"
import { useState } from "react"
import { useParams } from "react-router-dom"
import BFInput from "./BFInput"
import { ArrowForwardRounded } from "@mui/icons-material"

const getFieldsInput = (dbInputs) => {
  const fields = {}
  if (dbInputs.tshirt_size > 0)
    fields.tshirt_size = {
      input: "tshirt_size",
      type: "text",
      special: "tshirt",
    }
  if (dbInputs.diet > 0)
    fields.diet = {
      input: "diet",
      type: "boolean",
      label: "Besoins sp\u00e9cifiques",
      text: "Mon enfant a des besoins sp\u00e9cifiques",
      optional: true,
      description: [
        "Y-a-t-il des informations que les animatrices et animateurs devraient conna\u00eetre pour le bien-\u00eatre de votre enfant (allergie, maladie, m\u00e9dicaments, r\u00e9gime alimentaire ou autres particularit\u00e9s telles que difficult\u00e9 d\u2019adaptation, troubles du comportement, etc.), afin de nous permettre de g\u00e9rer au mieux les situations particuli\u00e8res ?",
      ],
    }
  if (dbInputs.risks_consent > 0)
    fields.risks_consent = {
      input: "risks_consent",
      type: "boolean",
      label: "D\u00e9roulement des ateliers",
      text: "J\u2019ai pris connaissance des risques, des conditions susmentionn\u00e9es et j\u2019accepte que mon enfant participe \u00e0 l\u2019atelier.",
      description: [
        "Les ateliers ont pour objectif de permettre une d\u00e9couverte du monde technique \u00e0 travers des activit\u00e9s pratiques, encadr\u00e9es par des professionnel\u00b7les. Les animatrices et animateurs assurent l\u2019encadrement et appliquent des consignes de s\u00e9curit\u00e9 ; cependant, comme pour toute activit\u00e9 pratique, le risque z\u00e9ro n\u2019existe pas. Des incidents peuvent exceptionnellement survenir lors de l\u2019utilisation du mat\u00e9riel (par exemple une br\u00fblure superficielle ou une petite coupure).",
        "En cas d\u2019incident/accident, les frais occasionn\u00e9s seront pris en charge par l\u2019assurance de votre enfant ou votre assurance responsabilit\u00e9 civile. Dans les limites l\u00e9gales, la HEIG-VD d\u00e9cline toute responsabilit\u00e9 en cas d\u2019accident. Toute pr\u00e9tention en dommages et int\u00e9r\u00eats de la part des parents envers la HEIG-VD est donc exclue.",
      ],
    }
  if (dbInputs.comportement > 0)
    fields.comportement = {
      input: "comportement",
      type: "boolean",
      label: "Comportement",
      text: "Je confirme avoir pris connaissance des r\u00e8gles de comportement et je m\u2019engage \u00e0 ce que mon enfant les respecte.",
      description: [
        "La participation \u00e0 un atelier implique que chaque enfant adopte une attitude respectueuse, s\u00e9curitaire et contribue au bon d\u00e9roulement des activit\u00e9s.",
        "En cas de non-respect de ces r\u00e8gles, l\u2019\u00e9quipe organisatrice se r\u00e9serve le droit de prendre les mesures appropri\u00e9es pour garantir la s\u00e9curit\u00e9 et le confort de toutes et tous. Cas \u00e9ch\u00e9ant, l\u2019enfant peut \u00eatre exclu de l\u2019atelier.",
      ],
    }
  if (dbInputs.media_consent > 0)
    fields.media_consent = {
      input: "media_consent",
      type: "boolean",
      label: "Droit \u00e0 l\u2019image",
      text: "J\u2019autorise l\u2019utilisation de photos et/ou vid\u00e9os de mon enfant",
      optional: true,
      description: [
        "Lors des ateliers, des photos et/ou vid\u00e9os pourront \u00eatre prises et publi\u00e9es sur le site Internet de la HEIG-VD et sur les r\u00e9seaux sociaux, voire utilis\u00e9es pour les rapports \u00e0 l\u2019intention de nos partenaires et/ou par les institutions partenaires, dans un but de promotion et de documentation des ateliers et des activit\u00e9s de la HEIG-VD. Il n\u2019est pas fait mention du nom des enfants sur les photos et/ou vid\u00e9os.",
      ],
    }
  if (dbInputs.transportation > 0)
    fields.transportation = {
      input: "transportation",
      type: "boolean",
      label: "Transport et accueil (pour WINS uniquement)",
      text: "Ma fille profitera du départ group\u00e9 \u00e0 la gare et je m\u2019engage \u00e0 payer le trajet si n\u00e9cessaire.",
      optional: true,
      description: [
        "Un d\u00e9part group\u00e9 est organis\u00e9 depuis la gare d\u2019Yverdon-les-Bains jusqu\u2019\u00e0 la HEIG-VD, via un bus du r\u00e9seau Travys. Un accueil \u00e0 la gare, le matin des deux jours, sera assur\u00e9 par des membres de l\u2019\u00e9quipe organisatrice de WINS.",
        "Si la participante ne dispose pas d\u2019un abonnement CFF qui couvre le trajet, l\u2019achat d\u2019un billet est \u00e0 sa charge.",
        "Les participantes qui le souhaitent peuvent se rendre directement \u00e0 la HEIG-VD."
      ],
    }
  if (dbInputs.unil_survey > 0)
    fields.unil_survey = {
      input: "unil_survey",
      type: "boolean",
      label: "Enqu\u00eate UNIL",
      text: "Je souhaite participer \u00e0 une enqu\u00eate de l\u2019UNIL",
      optional: true,
    }
  return fields
}

export default function SimpleInfos() {
  const { secret } = useParams()
  const { enqueueSnackbar } = useSnackbar()
  const {
    config: { inputs },
    dbReg,
  } = useSelector(getAdForm)
  const dispatch = useDispatch()
  const [disabledSubmit, setDisabledSubmit] = useState(false)

  const adForm = useSelector(getAdForm)
  const [dietDetails, setDietDetails] = useState(adForm.diet_details ?? "")
  const fieldsInput = getFieldsInput(inputs)

  const getInputValidators = ({ input, type, special = "", optional = false }) => {
    let config = !optional && inputs[input] === 1 ? "required|" : ""
    if (special) {
      if (special === "tshirt") config += "in:XS,S,M,L,XL"
    } else {
      if (type === "boolean") config += "array|in:ok"
    }
    return config
  }

  const [fields, errors, form] = useFormInputValidation(
    Object.keys(fieldsInput).reduce(
      (a, v) => ({
        ...a,
        [v]: adForm[v] ?? undefined,
      }),
      {}
    ),
    Object.keys(fieldsInput).reduce(
      (a, v) => ({
        ...a,
        [v]: getInputValidators(fieldsInput[v]),
      }),
      {}
    )
  )

  form.useLang("fr")
  form.setMessages(Lang.fr, { ...form.getMessages(Lang.fr), required: "Ce champ est requis" })

  const nextStep = (event) => {
    event.preventDefault()
    setDisabledSubmit(true)

    const isValid = Object.keys(fieldsInput).every((fieldName) => {
      const rule = getInputValidators(fieldsInput[fieldName])
      if (!rule || !rule.includes("required")) return true
      const value = fields[fieldName]
      if (fieldsInput[fieldName].type === "boolean") return value?.[0] === "ok"
      if (fieldsInput[fieldName].special === "tshirt") return ["XS", "S", "M", "L", "XL"].includes(value)
      return !!value
    })

    if (isValid) {
      const formattedFields = Object.keys(fields).reduce(
        (a, fieldName) => ({
          ...a,
          [fieldName]: fieldsInput[fieldName].type === "boolean" ? fields[fieldName]?.[0] === "ok" : fields[fieldName],
        }),
        {}
      )
      dispatch(
        putReg(dbReg._id, {
          registration: {
            ...formattedFields,
            ...(formattedFields.diet ? { diet_details: dietDetails } : { diet_details: "" }),
            admission_secret: secret,
          },
        })
      ).then((result) => {
        if (result === "ok") {
          enqueueSnackbar("Informations enregistrées.", { variant: "success" })
        }
        if (result === "error") {
          enqueueSnackbar("Une erreur est survenue lors de l'enregistrement des informations", {
            variant: "error",
          })
        }
        setDisabledSubmit(false)
      })
    } else {
      enqueueSnackbar("Veuillez remplir les champs obligatoires.", { variant: "warning" })
      setDisabledSubmit(false)
    }
  }

  return (
    <Card sx={{ p: 1 }}>
      <CardHeader
        title={
          <>
            <Typography variant="inherit" gutterBottom>
              {"Informations supplémentaires"}
            </Typography>
            <Typography variant="sub6">{"Nous avons encore besoin de quelques informations pour compléter l'inscription."}</Typography>
            <Typography noWrap sx={{ mt: 2, color: "primary.main" }}>
              <ArrowForwardRounded fontSize="inherit" sx={{ verticalAlign: "text-top", mr: 1 }} />
              {`Formulaire destiné à ${dbReg?.child?.firstname} ${dbReg?.child?.lastname}`}
            </Typography>
          </>
        }
      />

      <CardContent sx={{ display: "flex", flexDirection: "column", rowGap: 2 }}>
        {inputs["tshirt_size"] > 0 && (
          <TshirtSizeRF
            value={fields["tshirt_size"] ?? ""}
            onChange={form.handleChangeEvent}
            error={errors["tshirt_size"]}
            important={inputs["tshirt_size"] === 1 && !fieldsInput["tshirt_size"].optional}
          />
        )}
        {Object.values(fieldsInput)
          .filter((input) => input.type === "boolean")
          .map((input) => (
            <Box key={input.input}>
              <BFInput
                label={input.label}
                text={input.text}
                name={input.input}
                onChange={(e) => {
                  form.handleChangeEvent(e)
                  if (input.input === "diet" && !e.target.checked) setDietDetails("")
                }}
                error={errors[input.input]}
                important={inputs[input.input] === 1 && !fieldsInput[input.input].optional}
                description={input.description}
              />
              {input.input === "diet" && fields["diet"]?.[0] === "ok" && (
                // rows fixe + textarea natif + name : TextareaAutosize (multiline auto) rend
                // un 2e textarea caché sans name, et react-form-input-validation crashe
                // (null.endsWith) sur tout textarea du form sans attribut name
                <TextField
                  fullWidth
                  multiline
                  rows={2}
                  InputProps={{ inputComponent: "textarea" }}
                  name="diet_details"
                  size="small"
                  label={"Précisez lesquelles"}
                  value={dietDetails}
                  onChange={(e) => setDietDetails(e.target.value)}
                  sx={{ ml: 1, mt: 0.5 }}
                />
              )}
            </Box>
          ))}
        {!!inputs?.participation && (
          <Box>
            <FormLabel sx={{ fontWeight: "bold" }}>{"Participation (pour PRODIGE uniquement)"}</FormLabel>
            <Typography variant="body2" sx={{ ml: 1, mt: 1, color: "text.secondary" }}>
              {"Nous attirons votre attention sur le fait que l\u2019atelier Prodige est con\u00e7u comme un parcours progressif sur plusieurs jours. Pour en tirer pleinement b\u00e9n\u00e9fice et pouvoir finaliser le projet, il est donc attendu que les enfants soient pr\u00e9sents \u00e0 toutes les dates pr\u00e9vues."}
            </Typography>
          </Box>
        )}
      </CardContent>
      <CardActions>
        <Box sx={{ flex: 1, mt: 2, display: "flex", justifyContent: "flex-end" }}>
          <Button disabled={disabledSubmit} variant="contained" size="large" disableElevation onClick={nextStep}>
            {"Valider les informations"}
          </Button>
        </Box>
      </CardActions>
    </Card>
  )
}
